<template>
	<a class="text-decoration-none" role="button" :aria-label="'Link to ' + publication.Title" :href="publication.DetailsUrl">
		<article class="d-flex flex-column publication-card">
			<h3 class="m-0 text-primary large"><strong>{{publication.Title}}</strong></h3>
			<div class="d-none d-md-flex align-items-baseline">
        <span class="mt-1">{{getDate}}</span>
        <span v-if="publication.Author">
          <span class="mx-2">|</span>
          <span class="link">{{publication.Author}}</span>
        </span>
      </div>
      <div class="d-flex d-md-none align-items-baseline flex-wrap">
        <span class="mt-1 w-100">{{getDate}}</span>
        <span class="link w-100" v-if="publication.Author">{{publication.Author}}</span>
      </div>
			<div class="publication-card_description mt-3" v-html="publication.Description"></div>
		</article>
	</a>
</template>
<script>
  import { computed } from 'vue';
	import moment from 'moment';

  export default {
    name: 'PressReleaseCard',
    props: {
      publication: {
        type: Object,
        required: true
      }
    },
    setup(props) {
      const getDate = computed(() => {
        var date = "";
        if (props.publication.OriginalPublicationDate) {
          date = moment(String(props.publication.OriginalPublicationDate), 'MM-DD-YYYY').format('MMMM YYYY');
        }

        return date;
      });

      return {
        getDate
      };
    }
  };
</script>
